import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbComponent } from '../../components/bread-crumb/bread-crumb.component';
// import { BreadcrumbModule } from 'xng-breadcrumb';
import { MaterialModule } from 'src/app/shared/modules/material.module';
@NgModule({
  declarations: [BreadCrumbComponent],
  imports: [CommonModule, MaterialModule],
  exports: [BreadCrumbComponent],
})
export class BreadcrumbMenuModule {}
